import { CardInfoDto } from "./card-info.dto";

export class CardLinkDto {
   /*
   *
   */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public recommended?: boolean,
      public link?: string,
      public photo?: string,
      public cardInfo?: CardInfoDto
    ){}
    
}